export enum DashboardModalsKeys {
  EmailSuccessfullyVerified = 'EmailSuccessfullyVerified',
}